import { routerMiddleware } from 'connected-react-router';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { rootReducer } from '@/app/app-reducer';
import { rootSaga } from '@/app/app-saga-middleware';
import { ERROR_MESSAGES, ERROR_TYPES } from '@/error-boundaries/errors';
import { history } from './app-reducer';

// https://redux-saga.js.org/docs/api/#createsagamiddlewareoptions
const sagaMiddleware = createSagaMiddleware({
  // This is a catch all for uncaught errors in Sagas. This should only be called for app destruction errors
  onError: (err) => {
    console.error(err);
    store.dispatch({
      type: 'ERROR.SET_ERROR_STATE',
      payload: {
        errorType: ERROR_TYPES.DefaultException,
        errorMessage: ERROR_MESSAGES.DefaultException,
      },
    });
  },
});

export const store = createStore(
  rootReducer,
  {},
  composeWithDevTools(
    applyMiddleware(sagaMiddleware, routerMiddleware(history))
  )
);

sagaMiddleware.run(rootSaga);
